(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    const data = JSON.parse(root.querySelector('[data-pc-data]').textContent);
    const form = root.querySelector('.pc-purchase-form');
    const select = form.querySelector('[data-pc-variant]');
    const quantity = form.querySelector('[name="quantity"]');
    const atc = form.querySelector('.pc-atc');
    const hero = root.querySelector('.pc-hero-image');
    const thumbs = root.querySelector('[data-pc-thumbs]');
    const initial = data.variants.find(v => String(v.id) === String(data.initialVariant)) || data.variants[0];
    const options = [...initial.options];
    const colorPosition = data.colorPosition;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animate = () => root.dataset.animation !== 'false' && !reduced.matches;
    const abort = new AbortController();
    const timers = [];
    const imageTokens = new WeakMap();
    function groupFor(color) {
      if (root.dataset.productHandle !== 'plaid-en-fausse-fourrure' || colorPosition < 0) return data.images;
      const first = data.variants.find(v => v.options[colorPosition] === color && v.imageId);
      if (!first) return data.images;
      const start = data.images.findIndex(i => String(i.id) === String(first.imageId));
      if (start < 0) return data.images;
      const primaryIds = new Set(data.variants.filter(v => v.options[colorPosition] !== color).map(v => String(v.imageId)));
      let end = start + 1;
      while (end < data.images.length && !primaryIds.has(String(data.images[end].id))) end++;
      return data.images.slice(start, end);
    }
    async function showImage(element, photo) {
      if (!photo) return;
      const token = (imageTokens.get(element) || 0) + 1;
      imageTokens.set(element, token);
      if (element.dataset.pcImageId === String(photo.id)) return;
      const preload = new Image();
      preload.sizes = element.sizes || '100vw';
      if (photo.srcset) preload.srcset = photo.srcset;
      preload.src = photo.src;
      try { await preload.decode(); } catch {}
      if (!root.isConnected || token !== imageTokens.get(element)) return;
      if (photo.srcset) element.srcset = photo.srcset;
      if (photo.width && photo.height) {
        element.width = photo.width;
        element.height = photo.height;
      }
      element.src = photo.src; element.alt = photo.alt || '';
      element.dataset.pcImageId = String(photo.id);
      if (animate()) element.animate([{ opacity: .25 }, { opacity: 1 }], { duration: 500, easing: 'ease-out' });
    }
    function renderGallery(variant) {
      const photos = groupFor(options[colorPosition]);
      const active = data.images.find(i => String(i.id) === String(variant?.imageId)) || photos[0];
      if (active) showImage(hero, active);
      thumbs.replaceChildren();
      photos.forEach((photo, index) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', 'Voir la photo ' + (index + 1));
        button.setAttribute('aria-pressed', String(photo === active));
        const img = document.createElement('img'); img.src = photo.thumb; img.alt = ''; img.width = 64; img.height = 64;
        button.append(img);
        button.onclick = () => { showImage(hero, photo); thumbs.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button))); };
        thumbs.append(button);
      });
    }
    function render(updateUrl = false) {
      const variant = data.variants.find(v => v.options.every((value, index) => value === options[index]));
      root.querySelectorAll('[data-option-position]').forEach(fieldset => {
        const position = Number(fieldset.dataset.optionPosition);
        fieldset.querySelector('[data-option-label]').textContent = options[position];
        fieldset.querySelectorAll('[data-option-value]').forEach(button => {
          const desired = options.map((value, index) => index === position ? button.dataset.optionValue : value);
          const candidate = data.variants.find(v => v.options.every((value, index) => value === desired[index]));
          button.setAttribute('aria-pressed', String(button.dataset.optionValue === options[position]));
          button.setAttribute('aria-disabled', String(!candidate?.available));
          button.classList.toggle('pc-option-unavailable', !candidate?.available);
          button.setAttribute('aria-label', button.dataset.optionValue + (!candidate ? ' — combinaison non proposée' : !candidate.available ? ' — indisponible' : ''));
        });
      });
      root.querySelector('[data-pc-price]').textContent = variant ? variant.price : 'Combinaison non proposée';
      atc.disabled = !variant?.available;
      atc.textContent = variant?.available ? 'Ajouter au panier' : 'Indisponible';
      const express = root.querySelector('.pc-express');
      if (express) express.disabled = !variant?.available;
      select.value = variant ? String(variant.id) : '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (variant) {
        quantity.min = variant.min; quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = Math.max(variant.min, Number(quantity.value) || variant.min);
        renderGallery(variant);
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      }
      root.querySelector('.pc-status').textContent = variant ? '' : 'Cette combinaison de couleur et de format n’est pas proposée.';
    }
    root.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
      const position = Number(button.closest('fieldset').dataset.optionPosition);
      options[position] = button.dataset.optionValue;
      render(true);
    }, { signal: abort.signal }));
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      const step = Number(quantity.step) || 1;
      const min = Number(quantity.min) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      quantity.value = Math.max(min, Math.min(max, (Number(quantity.value) || min) + Number(button.dataset.quantity) * step));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal: abort.signal }));
    root.querySelectorAll('[data-info]').forEach(button => button.addEventListener('click', () => {
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-info]').forEach(other => {
        const panel = document.getElementById(other.dataset.info);
        const open = other === button && willOpen;
        other.setAttribute('aria-expanded', String(open));
        if (panel) panel.hidden = !open;
      });
    }, { signal: abort.signal }));
    const dial = root.querySelector('.pc-texture-visual');
    if (dial) {
      let index = 0;
      dial.querySelectorAll('[data-dial-step]').forEach(button => button.addEventListener('click', () => {
        index = (index + Number(button.dataset.dialStep) + data.colorNames.length) % data.colorNames.length;
        const color = data.colorNames[index];
        const variantPhoto = data.variants.find(v => v.options[colorPosition] === color && v.imageId);
        const photo = data.images.find(image => String(image.id) === String(variantPhoto?.imageId)) || groupFor(color)[0];
        showImage(dial.querySelector('img'), photo);
        const label = dial.querySelector('.pc-dial-color'); label.replaceChildren(document.createTextNode(color));
        const count = document.createElement('span'); count.className = 'pc-dial-count'; count.textContent = (index + 1) + ' / ' + data.colorNames.length; label.append(count);
      }, { signal: abort.signal }));
      if (colorPosition < 0 || data.colorNames.length < 2) dial.querySelector('.pc-color-dial').hidden = true;
    }
    const slots = [...root.querySelectorAll('.pc-product-slot')];
    const pool = root.querySelector('[data-pc-product-pool]');
    const catalog = [...root.querySelectorAll('.pc-worlds .pc-product-tile')];
    let nextCard = slots.length;
    const visible = new Set();
    const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)), { threshold: .15 });
    slots.forEach((slot, index) => {
      observer.observe(slot);
      const advance = async () => {
        if (!pool || !animate() || document.hidden || !visible.has(slot) || slot.matches(':hover') || slot.contains(document.activeElement) || !root.isConnected || slot.dataset.changing) return;
        const previous = slot.querySelector('.pc-product-tile:not([hidden])');
        if (!previous || catalog.length <= slots.length) return;
        let incoming;
        for (let attempt = 0; attempt < catalog.length; attempt++) {
          const candidate = catalog[nextCard % catalog.length];
          nextCard = (nextCard + 1) % catalog.length;
          if (candidate.parentElement === pool) { incoming = candidate; break; }
        }
        if (!incoming) return;
        slot.dataset.changing = 'true';
        incoming.hidden = true;
        slot.append(incoming);
        const image = incoming.querySelector('img');
        const preload = new Image(); preload.src = image.currentSrc || image.src;
        try { await preload.decode(); } catch {}
        if (!root.isConnected || !animate() || document.hidden || !visible.has(slot) || slot.contains(document.activeElement)) {
          pool.append(incoming);
          delete slot.dataset.changing;
          return;
        }
        previous.classList.add('pc-tile-leave'); previous.inert = true; previous.setAttribute('aria-hidden', 'true');
        incoming.hidden = false; incoming.classList.add('pc-tile-enter');
        timers.push(setTimeout(() => {
          previous.hidden = true; previous.classList.remove('pc-tile-leave'); previous.inert = false; previous.removeAttribute('aria-hidden');
          pool.append(previous);
          incoming.classList.remove('pc-tile-enter'); delete slot.dataset.changing;
        }, 2050));
      };
      timers.push(setTimeout(() => { advance(); timers.push(setInterval(advance, Number(root.dataset.interval) || 6000)); }, (Number(root.dataset.interval) || 6000) + index * 2000));
    });
    form.addEventListener('submit', event => {
      if (atc.disabled || !select.value || !quantity.checkValidity()) { event.preventDefault(); quantity.reportValidity(); }
    }, { signal: abort.signal });
    root.querySelector('.pc-custom-options').hidden = false;
    select.hidden = true;
    root.querySelector('.pc-fallback-label').hidden = true;
    root.dataset.ready = 'true';
    render();
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { abort.abort(); observer.disconnect(); timers.forEach(timer => { clearTimeout(timer); clearInterval(timer); }); } }, { signal: abort.signal });
  }
  document.querySelectorAll('[data-pc-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pc-product]').forEach(initialize));
})();


